/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_3_QInputs */

const en_control_faq_3_q = /** @type {(inputs: Control_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are puzzle answers designed for fast lookup?`)
};

const zh_control_faq_3_q = /** @type {(inputs: Control_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`谜题答案方便快速查询吗？`)
};

/**
* | output |
* | --- |
* | "Are puzzle answers designed for fast lookup?" |
*
* @param {Control_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_3_q = /** @type {((inputs?: Control_Faq_3_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_3_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_3_q(inputs)
	return zh_control_faq_3_q(inputs)
});
export { control_faq_3_q as "control.faq.3.q" }